module.exports = __webpack_public_path__ + "img/operate-w.5d4fdb9e.svg";